function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DS = window.WinBoostAiDesignSystem_0f78b0 || {};
var Button = DS.Button,
  IconButton = DS.IconButton,
  Card = DS.Card,
  Badge = DS.Badge,
  CheckItem = DS.CheckItem,
  SectionLabel = DS.SectionLabel,
  Icon = DS.Icon,
  Orbit = DS.Orbit,
  StatBlock = DS.StatBlock,
  Select = DS.Select,
  Accordion = DS.Accordion;
var COVER = [['Bo\u00eete vocale seulement', 'D\u00e9bordements et appels manqu\u00e9s', 4], ['Apr\u00e8s les heures', "17 h \u2013 minuit", 6], ['Soirs', "21 h \u2013 minuit", 4], ['Heures d\u2019ouverture', "9 h \u2013 17 h", 15], ['24/7', 'Toujours en r\u00e9ponse', 20]];
var STEPS = [['Choisissez vos agents', 'Appels entrants, appels sortants, textos, dans toutes les langues de vos appelants.'], ['Remplissez le formulaire', "Simple et rapide\u00a0: la plupart des entreprises terminent en moins de 7 minutes. Choisissez le comportement de votre voix IA, ajoutez vos fichiers d\u2019int\u00e9gration et de vente, et c\u2019est tout. On s\u2019occupe du reste."], ['Nous le configurons en moins de 7 jours', 'Cr\u00e9ation, connexion, tests, validation par le client, touches finales. Sans compter l\u2019enregistrement A2P 10DLC.'], ['Mise en service', 'Donnez \u00e0 chaque occasion une meilleure chance d\u2019obtenir une r\u00e9ponse.']];
function Onboarding() {
  return React.createElement(Section, {
    id: "onboarding"
  }, React.createElement(Head, {
    index: "14",
    label: "Mise en route",
    title: "De la configuration \u00e0 la mise en service en 4 \u00e9tapes.",
    lead: "Pas de projet d\u2019approvisionnement, pas de migration de syst\u00e8me t\u00e9l\u00e9phonique. La plupart des entreprises sont en service en moins d\u2019une semaine."
  }), React.createElement(FlipSteps, {
    steps: STEPS
  }), React.createElement("div", {
    style: {
      marginTop: 'clamp(20px,2.2vw,32px)'
    }
  }, React.createElement(LetsTalk, null)));
}
var CFG = [{
  id: 'in',
  name: 'AI Phone appels entrants',
  tag: 'Le plus choisi',
  price: 2997,
  icon: 'M21.5 16.4v2.9a1.9 1.9 0 0 1-2.1 1.9 18.8 18.8 0 0 1-8.2-2.9 18.5 18.5 0 0 1-5.7-5.7A18.8 18.8 0 0 1 2.6 4.4 1.9 1.9 0 0 1 4.5 2.5h2.9a1.9 1.9 0 0 1 1.9 1.6c.1.9.4 1.8.7 2.7a1.9 1.9 0 0 1-.4 2L8.4 10a15.2 15.2 0 0 0 5.7 5.7l1.2-1.2a1.9 1.9 0 0 1 2-.4c.9.3 1.8.6 2.7.7a1.9 1.9 0 0 1 1.6 1.9ZM21 3l-5.5 5.5M15.5 3.8v4.7h4.7',
  desc: 'R\u00e9pond \u00e0 chaque appel entrant 24/7, qualifie l\u2019appelant et prend le rendez-vous. Les leads re\u00e7oivent leur confirmation de r\u00e9servation par texto pendant l\u2019appel, un rappel 24 heures avant et un autre 2 heures avant le rendez-vous, chacun avec un lien de reprogrammation au besoin.',
  bullets: ['R\u00e9ponse aux appels 24/7', 'Qualification et r\u00e9servation', 'Confirmation et rappels par texto']
}, {
  id: 'out',
  name: 'AI Phone appels sortants',
  price: 2997,
  icon: 'M21.5 16.4v2.9a1.9 1.9 0 0 1-2.1 1.9 18.8 18.8 0 0 1-8.2-2.9 18.5 18.5 0 0 1-5.7-5.7A18.8 18.8 0 0 1 2.6 4.4 1.9 1.9 0 0 1 4.5 2.5h2.9a1.9 1.9 0 0 1 1.9 1.6c.1.9.4 1.8.7 2.7a1.9 1.9 0 0 1-.4 2L8.4 10a15.2 15.2 0 0 0 5.7 5.7l1.2-1.2a1.9 1.9 0 0 1 2-.4c.9.3 1.8.6 2.7.7a1.9 1.9 0 0 1 1.6 1.9ZM15.5 8.5 21 3M16.3 3H21v4.7',
  desc: 'Appelle votre liste, assure le suivi des nouveaux leads et r\u00e9active les anciennes occasions. Chaque nouveau flux de travail compte comme une nouvelle r\u00e9vision.',
  bullets: ['Suivi des leads \u00e0 grande \u00e9chelle', 'Campagnes de r\u00e9activation', 'Textos pendant les appels']
}, {
  id: 'orb',
  name: 'Active AI Orbit',
  tag: 'Site Web',
  price: 1997,
  icon: 'M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM5.94 8.5A7 3 30 1 0 18.06 15.5A7 3 30 1 0 5.94 8.5ZM5.94 15.5A7 3 -30 1 0 18.06 8.5A7 3 -30 1 0 5.94 15.5ZM12 5A3 7 0 1 0 12 19A3 7 0 1 0 12 5Z',
  desc: 'Une exp\u00e9rience vocale sur votre site Web. Les visiteurs lui parlent au lieu d\u2019\u00e9crire, obtiennent des r\u00e9ponses en temps r\u00e9el et r\u00e9servent directement dans votre calendrier.',
  bullets: ['Parle en direct avec les visiteurs', 'R\u00e9pond et qualifie', 'R\u00e9serve dans votre calendrier']
}, {
  id: 'sms',
  name: 'AI Phone d\u2019avis par SMS',
  tag: 'Option',
  price: 697,
  was: 997,
  icon: 'M21.5 14.5a2 2 0 0 1-2 2H8l-4.5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z',
  star: 'M12.5 5.4l1.3 2.7 3 .4-2.2 2.1.5 3-2.6-1.4-2.6 1.4.5-3-2.2-2.1 3-.4Z',
  note: 'N\u00e9cessite les appels entrants ou sortants. \u00c9conomisez 147\u00a0$ avec un ensemble.',
  desc: 'Demande des avis, assure le suivi et achemine les commentaires apr\u00e8s chaque travail termin\u00e9.',
  bullets: ['Demandes d\u2019avis', 'Gestion des r\u00e9ponses', 'Rapports de r\u00e9putation']
}];
var PRESETS = [{
  label: 'AI Phone appels entrants',
  ids: ['in'],
  grp: 0
}, {
  label: 'AI Phone appels sortants',
  ids: ['out'],
  grp: 0
}, {
  label: 'Active AI Orbit',
  sub: 'Site Web vocal',
  ids: ['orb'],
  grp: 0
}, {
  label: 'AI Phone d\u2019avis par SMS',
  ids: ['sms'],
  grp: 0
}, {
  label: 'AI Phone appels entrants + SMS',
  ids: ['in', 'sms'],
  grp: 1
}, {
  label: 'AI Phone appels sortants + SMS',
  ids: ['out', 'sms'],
  grp: 1
}, {
  label: 'AI Phone appels entrants + sortants',
  ids: ['in', 'out'],
  grp: 1
}, {
  label: 'AI Phone complet',
  sub: 'Entrants + sortants + SMS',
  ids: ['in', 'out', 'sms'],
  grp: 1,
  best: 'Meilleure valeur'
}, {
  label: 'AI Phone complet + Active AI Orbit',
  sub: 'Entrants + sortants + SMS + site Web',
  ids: ['in', 'out', 'sms', 'orb'],
  grp: 1,
  best: 'Tout inclus'
}];
var A = '../../assets/';
var money = function money(n) {
  return n.toLocaleString('fr-CA') + "\u00a0$";
};
function quote(ids) {
  var list = CFG.filter(function (c) {
    return ids.includes(c.id);
  }).reduce(function (a, c) {
    return a + c.price;
  }, 0);
  var i = ids.includes('in'),
    o = ids.includes('out'),
    m = ids.includes('sms');
  var save = i && o && m ? 744 : i && o ? 550 : (i || o) && m ? 147 : 0;
  return {
    list: list,
    save: save,
    total: list - save
  };
}
function Products() {
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    sel = _React$useState2[0],
    setSel = _React$useState2[1];
  var _React$useState3 = React.useState(2),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    sites = _React$useState4[0],
    setSites = _React$useState4[1];
  var picked = CFG.filter(function (c) {
    return sel.includes(c.id);
  });
  var q = quote(sel);
  var toggle = function toggle(id) {
    var n = sel.includes(id) ? sel.filter(function (x) {
      return x !== id;
    }) : CFG.map(function (x) {
      return x.id;
    }).filter(function (x) {
      return x === id || sel.includes(x);
    });
    if (n.includes('sms') && !n.includes('in') && !n.includes('out')) n = n.filter(function (x) {
      return x !== 'sms';
    });
    setSel(n);
  };
  return React.createElement(Section, {
    id: "products",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    index: "10",
    label: "Exp\u00e9rience produit",
    title: "Les produits et ensembles AI Phone"
  }), React.createElement("style", null, '.pr-own{display:grid;grid-template-columns:minmax(0,1.15fr) minmax(0,1fr);gap:clamp(18px,2.6vw,40px);align-items:center}.pr-tiles{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:clamp(16px,2vw,26px)}@media(max-width:900px){.pr-own{grid-template-columns:1fr}.pr-tiles{grid-template-columns:1fr}}'), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(18px,2vw,26px)',
      marginBottom: 'clamp(18px,2vw,28px)'
    }
  }, React.createElement("div", {
    className: "pr-own",
    style: {
      position: 'relative',
      overflow: 'hidden',
      border: '1.5px solid var(--wb-orange)',
      borderRadius: 'var(--radius-xl)',
      background: 'var(--wb-white)',
      padding: 'clamp(20px,2.2vw,28px)',
      boxShadow: '0 16px 40px rgba(23,23,23,.09)'
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: '0 0 auto',
      height: 4,
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)'
    }
  }), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      minWidth: 0
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "La m\u00e9thode WinBoost \u00b7 poss\u00e9dez-le, ne le louez pas"), React.createElement("p", {
    style: {
      fontSize: 'clamp(20px,2vw,27px)',
      lineHeight: 1.3,
      fontWeight: 800,
      letterSpacing: '-.025em',
      margin: 0
    }
  }, "Poss\u00e9dez votre AI Phone, comme votre t\u00e9l\u00e9phone intelligent.", React.createElement("br", null), React.createElement("span", {
    style: {
      background: 'var(--grad-brand)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "Ensuite, payez seulement les minutes pendant lesquelles il parle.")), React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.55,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "Partout ailleurs, vous louez\u00a0: cessez de payer l\u2019abonnement mensuel et le t\u00e9l\u00e9phone n\u2019est plus \u00e0 vous. Ici, vous l\u2019achetez une fois et vous le gardez.")), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      minWidth: 0
    }
  }, [["Con\u00e7u pour votre entreprise, puis il est \u00e0 vous", 'Achetez-le comptant ou financez-le.'], ['H\u00e9berg\u00e9 dans notre nuage', 'Rien \u00e0 g\u00e9rer ni \u00e0 entretenir de votre c\u00f4t\u00e9.'], ['Payez seulement ce que vous utilisez', 'Minutes et textos, factur\u00e9s par votre portail client.']].map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      h = _ref2[0],
      s = _ref2[1];
    return React.createElement("div", {
      key: h,
      style: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10
      }
    }, React.createElement("span", {
      "aria-hidden": "true",
      style: {
        flex: '0 0 auto',
        width: 22,
        height: 22,
        marginTop: 1,
        borderRadius: '50%',
        background: 'var(--grad-brand-soft)',
        border: '1px solid rgba(252,99,6,.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, React.createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none"
    }, React.createElement("path", {
      d: "M5 12.5l4.5 4.5L19 7.5",
      stroke: "var(--wb-orange)",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), React.createElement("span", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        minWidth: 0
      }
    }, React.createElement("strong", {
      style: {
        fontSize: 15,
        fontWeight: 800,
        color: 'var(--text-primary)'
      }
    }, h), React.createElement("span", {
      style: {
        fontSize: 14,
        lineHeight: 1.45,
        color: 'var(--text-secondary)'
      }
    }, s)));
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 14
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-500)',
      whiteSpace: 'nowrap'
    }
  }, "Con\u00e7u pour gagner"), React.createElement("span", {
    style: {
      flex: 1,
      height: 1,
      background: 'var(--border-hairline)'
    }
  })), React.createElement("div", {
    className: "pr-tiles"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("h3", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      letterSpacing: '.12em'
    }
  }, "Con\u00e7u pour \u00e9voluer avec votre entreprise."), React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.65,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "Votre entreprise \u00e9voluera. Votre AI Phone aussi. C\u2019est pourquoi chaque nouveau ", React.createElement("strong", {
    style: {
      background: 'var(--wb-orange)',
      color: 'var(--wb-white)',
      fontWeight: 700,
      padding: '1px 4px',
      borderRadius: 3,
      boxDecorationBreak: 'clone',
      WebkitBoxDecorationBreak: 'clone'
    }
  }, "WinBoost AI Phone comprend 7 ans de mises \u00e0 jour logicielles et de s\u00e9curit\u00e9, jusqu\u2019\u00e0 4 r\u00e9visions d\u2019optimisation la premi\u00e8re ann\u00e9e"), ", ainsi que des am\u00e9liorations continues de la plateforme. Ainsi, votre AI Phone suit le rythme.")), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("h3", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      letterSpacing: '.12em'
    }
  }, "Besoin de plus de changements? Aucun probl\u00e8me."), React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.65,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "\u00c0 mesure que votre entreprise grandit, vos besoins peuvent changer. Que vous lanciez un nouveau service, vous \u00e9tendiez \u00e0 de nouveaux march\u00e9s ou connectiez de nouveaux logiciels, nous sommes l\u00e0 pour vous aider. Des forfaits d\u2019am\u00e9lioration suppl\u00e9mentaires sont offerts chaque fois que vous devez faire \u00e9voluer votre syst\u00e8me.")))), React.createElement("style", null, '.cv{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px}@media(max-width:1180px){.cv{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:520px){.cv{grid-template-columns:repeat(2,minmax(0,1fr))}}.cv button{display:flex;flex-direction:column;align-items:flex-start;gap:2px;padding:10px 13px;border:1.5px solid var(--border-card);border-radius:12px;background:var(--wb-white);font:inherit;text-align:left;cursor:pointer;transition:border-color var(--dur-fast) var(--ease-standard),transform var(--dur-fast) var(--ease-standard)}.cv button:hover{border-color:var(--wb-orange);transform:translateY(-1px)}.cv button.is-on{border-color:var(--wb-orange);box-shadow:0 0 0 2px var(--wb-orange) inset}.cv b{font-size:13px;font-weight:800;color:var(--text-primary)}.cv i{font-style:normal;font-size:11.5px;font-weight:700;color:var(--ink-500)}.cf-zone{position:relative;border:1.5px solid rgba(252,99,6,.4);border-radius:calc(var(--radius-xl) + 6px);background:var(--wb-white);padding:clamp(18px,2vw,32px);margin-top:clamp(14px,1.6vw,22px);box-shadow:0 0 0 9px rgba(252,99,6,.055),0 28px 64px rgba(23,23,23,.11)}.cf-zone:before{content:"";position:absolute;inset:-1.5px;border-radius:inherit;pointer-events:none;background:radial-gradient(120% 70% at 50% 0%,rgba(252,99,6,.08),transparent 62%)}.cf-zone>*{position:relative}.cf-hd{display:flex;flex-direction:column;align-items:center;text-align:center;gap:9px;margin:0 0 clamp(14px,1.5vw,20px)}.cf-eye{display:inline-flex;align-items:center;gap:12px;font-size:11px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;color:var(--wb-orange)}.cf-eye i{width:28px;height:1px;background:var(--wb-orange);opacity:.55}.cf-grad{background:var(--grad-brand);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-box-decoration-break:clone;box-decoration-break:clone;padding-bottom:.08em}.cf-h3{font-size:clamp(23px,2.5vw,33px);font-weight:800;text-transform:uppercase;letter-spacing:-.015em;line-height:1.1;margin:0;max-width:800px;text-wrap:balance}.cf-hlead{margin:0;max-width:700px;font-size:clamp(14.5px,1.3vw,16px);line-height:1.5;color:var(--text-secondary);text-wrap:pretty}.cf-steps{list-style:none;display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:2px 0 0;padding:0}.cf-steps li{display:inline-flex;align-items:center;gap:8px;padding:6px 14px 6px 7px;border:1px solid var(--border-card);border-radius:999px;background:var(--wb-white);font-size:13px;font-weight:800;color:var(--text-primary)}.cf-steps b{flex:none;width:19px;height:19px;border-radius:50%;background:var(--wb-orange);color:var(--wb-white);font-size:11.5px;font-weight:800;display:grid;place-items:center}.cf-cue{display:inline-flex;align-items:center;gap:9px;margin-top:0;text-decoration:none;cursor:pointer;transition:transform var(--dur-fast) var(--ease-standard),filter var(--dur-fast) var(--ease-standard);padding:10px 20px;border-radius:999px;background:var(--wb-orange);color:var(--wb-white);font-size:13.5px;font-weight:800;letter-spacing:.02em;box-shadow:0 8px 20px rgba(252,99,6,.28)}.cf-cue:hover{transform:translateY(-1px);filter:brightness(1.06)}.cf-cue svg{width:15px;height:15px;stroke:var(--wb-white);animation:cfbob 1.9s var(--ease-standard) infinite}@keyframes cfbob{0%,100%{transform:translateY(0)}50%{transform:translateY(3px)}}@media(prefers-reduced-motion:reduce){.cf-cue svg{animation:none}}.cf-groups{display:flex;flex-direction:column;gap:clamp(10px,1.1vw,14px);margin:0 0 clamp(13px,1.4vw,18px)}.cf-glb{display:flex;align-items:center;gap:13px;margin:0 0 7px}.cf-glb span:first-child{white-space:nowrap}.cf-glb i{flex:1;height:1px;background:var(--border-hairline)}.cf-gsv{font-size:11px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:var(--green-500);white-space:nowrap}.cf-pre{display:grid;gap:8px}.cf-pre.g0{grid-template-columns:repeat(4,minmax(0,1fr))}.cf-pre.g1{grid-template-columns:repeat(auto-fit,minmax(190px,1fr))}.cf-row.is-dis{cursor:not-allowed}.cf-row.is-dis>.cf-box,.cf-row.is-dis>.cf-ico,.cf-row.is-dis>.cf-rpr,.cf-row.is-dis .cf-rnm,.cf-row.is-dis .cf-rdsc,.cf-row.is-dis .cf-rbl{opacity:.5}.cf-row.is-dis .cf-hint{color:var(--text-primary)}.cf-row.is-dis:hover{transform:none}@media(max-width:820px){.cf-pre.g0,.cf-pre.g1{grid-template-columns:repeat(auto-fit,minmax(150px,1fr))}}.cf-chip{position:relative;display:flex;flex-direction:column;align-items:flex-start;gap:4px;padding:11px 13px 10px;border:1.5px solid var(--border-card);border-radius:14px;background:var(--wb-white);font:inherit;text-align:left;cursor:pointer;overflow:hidden;transition:transform var(--dur-base) var(--ease-standard),border-color var(--dur-base) var(--ease-standard),box-shadow var(--dur-base) var(--ease-standard)}.cf-chip:hover{transform:translateY(-2px);border-color:var(--wb-orange)}.cf-chip.is-on{border-color:var(--wb-orange);box-shadow:0 0 0 2px var(--wb-orange) inset}.cf-chip.has-badge{padding-top:24px}.cf-csub{font-size:10.5px;font-weight:700;line-height:1.35;color:var(--ink-500);margin-top:-2px}.cf-chip.tier4 .cf-csub,.tier3 .cf-csub{color:var(--text-secondary)}.cf-cnm{font-size:13px;font-weight:800;letter-spacing:-.01em;line-height:1.3;color:var(--text-primary)}.cf-chip b{font-size:clamp(18px,1.7vw,21px);font-weight:800;letter-spacing:-.04em;line-height:1;color:var(--text-primary);font-variant-numeric:tabular-nums}.cf-csv{font-size:10.5px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:var(--green-500)}.cf-chip.tier1 .cf-csv{color:var(--ink-500)}.cf-chip.tier2{background:#FFF8F3;border-color:rgba(252,99,6,.5)}.cf-chip.tier3,.tier4{background:var(--wb-white);border-color:var(--wb-orange);box-shadow:0 10px 28px rgba(252,99,6,.2)}.cf-chip.tier3:hover{border-color:var(--wb-orange);box-shadow:0 14px 34px rgba(252,99,6,.32)}.cf-chip.tier4.is-on,.tier3.is-on{border-color:var(--wb-orange);box-shadow:0 0 0 2px var(--wb-orange) inset,0 14px 34px rgba(252,99,6,.32)}.cf-chip.tier3 .cf-cnm,.cf-chip.tier3 b,.tier4 .cf-cnm,.cf-chip.tier4 b{color:var(--wb-orange)}.cf-chip.tier3 .cf-csv,.tier4 .cf-csv{color:var(--green-500)}.cf-best{position:absolute;top:0;left:0;right:0;padding:4px 10px;background:var(--wb-orange);color:var(--wb-white);font-size:9.5px;font-weight:800;letter-spacing:.14em;text-transform:uppercase}.cf-g{display:grid;grid-template-columns:minmax(0,1.55fr) minmax(0,1fr);gap:clamp(13px,1.4vw,18px);align-items:start}@media(max-width:900px){.cf-g{grid-template-columns:minmax(0,1fr)}}.cf-pick{display:flex;flex-direction:column;gap:8px;min-width:0}.cf-ess{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}.cf-ess .cf-row{height:100%;grid-template-columns:22px 40px minmax(0,1fr);grid-template-rows:auto 1fr;align-items:center;row-gap:12px}.cf-ess .cf-rpr{grid-column:3;grid-row:1;justify-self:end;align-items:flex-end}.cf-ess .cf-rm{grid-column:1/-1;grid-row:2;align-self:start}.cf-ess .cf-rbl{display:none}.cf-ess .cf-rdsc{font-size:13.5px;line-height:1.45}.cf-ess .cf-row{padding:14px 16px}.cf-adv{display:flex;flex-direction:column;gap:8px;min-width:0}@media(min-width:901px){.cf-pick{grid-column:1;grid-row:1}.cf-sum{grid-column:2;grid-row:1}.cf-adv{grid-column:1/-1;grid-row:2}}@media(max-width:620px){.cf-ess{grid-template-columns:minmax(0,1fr)}}.cf-row{display:grid;grid-template-columns:22px 40px minmax(0,1fr) auto;gap:clamp(12px,1.4vw,18px);align-items:start;width:100%;text-align:left;padding:clamp(12px,1.3vw,16px) clamp(14px,1.5vw,18px);border:1px solid var(--border-card);border-radius:var(--radius-lg);background:var(--wb-white);font:inherit;color:inherit;cursor:pointer;transition:border-color var(--dur-base) var(--ease-standard),box-shadow var(--dur-base) var(--ease-standard),background var(--dur-base) var(--ease-standard)}.cf-row:hover{border-color:var(--ink-400);background:var(--sand-100)}.cf-row.is-on{border-color:var(--wb-orange);background:#FFF8F3;box-shadow:0 0 0 1px var(--wb-orange) inset}.cf-box{width:22px;height:22px;border-radius:6px;border:1.5px solid var(--ink-400);display:grid;place-items:center;margin-top:1px;transition:all var(--dur-base) var(--ease-standard)}.cf-row.is-on .cf-box{border-color:transparent;background:var(--wb-orange)}.cf-box svg{width:13px;height:13px;opacity:0;transition:opacity var(--dur-fast) var(--ease-standard)}.cf-row.is-on .cf-box svg{opacity:1}.cf-ico{position:relative;width:40px;height:40px;border-radius:11px;background:var(--sand-100);border:1px solid var(--border-hairline);display:grid;place-items:center;transition:all var(--dur-base) var(--ease-standard)}.cf-row.is-on .cf-ico{background:var(--wb-orange);border-color:transparent}.cf-ico svg{width:21px;height:21px;stroke:var(--ink-500)}.cf-row.is-on .cf-ico svg{stroke:var(--wb-white)}.cf-hint{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:var(--wb-orange)}.cf-row.is-on .cf-hint{color:var(--green-500)}.cf-nt{align-self:flex-start;font-size:11.5px;font-weight:800;color:var(--wb-white);background:var(--wb-orange);border-radius:999px;padding:3px 10px}@media(max-width:560px){.cf-row{grid-template-columns:22px minmax(0,1fr)}.cf-ico{display:none}.cf-rpr{grid-column:2;align-items:flex-start}}.cf-rm{display:flex;flex-direction:column;gap:5px;min-width:0}.cf-rnm{display:flex;align-items:baseline;gap:9px;flex-wrap:wrap;font-size:13px;font-weight:800;letter-spacing:.16em;text-transform:uppercase}.cf-rtag{font-style:normal;font-size:10.5px;font-weight:800;letter-spacing:.16em;color:var(--wb-orange)}.cf-rdsc{font-size:14px;line-height:1.5;color:var(--text-secondary)}.cf-rbl{display:flex;flex-wrap:wrap;gap:6px;margin-top:2px}.cf-rbl span{font-size:11.5px;font-weight:700;letter-spacing:.02em;color:var(--ink-500);border:1px solid var(--border-hairline);border-radius:999px;padding:3px 9px;background:var(--wb-white)}.cf-rpr{display:flex;flex-direction:column;align-items:flex-end;gap:3px;white-space:nowrap}.cf-rpr b{font-size:clamp(21px,2vw,26px);font-weight:800;letter-spacing:-.035em;line-height:1}.cf-rpr em{font-style:normal;font-size:10px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-500)}.cf-sum{position:relative;background:var(--wb-white);border:1px solid var(--border-card);border-radius:var(--radius-xl);padding:clamp(18px,1.9vw,26px) clamp(17px,1.8vw,24px);display:flex;flex-direction:column;gap:12px;overflow:hidden;box-shadow:0 20px 50px rgba(23,23,23,.1)}@media(max-width:900px){.cf-sum{position:static}}.cf-sum:before{content:"";position:absolute;inset:0 0 auto;height:4px;background:var(--wb-orange)}.cf-shd{display:flex;align-items:center;gap:12px}.cf-shd span{line-height:1.25}.cf-li{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:8px}.cf-li li{display:flex;justify-content:space-between;gap:14px;font-size:14px;font-weight:700;color:var(--text-secondary)}.cf-li li span:last-child{font-variant-numeric:tabular-nums;color:var(--text-primary);font-weight:800;white-space:nowrap}.cf-li .cf-empty{color:var(--ink-500);font-weight:600;font-style:italic}.cf-sv{display:flex;justify-content:space-between;gap:12px;align-items:center;padding:10px 13px;border-radius:10px;background:var(--wb-orange);font-size:13.5px;font-weight:800;color:var(--wb-white);box-shadow:0 6px 18px rgba(252,99,6,.26)}.cf-sv span:last-child{font-variant-numeric:tabular-nums}.cf-tot{display:flex;align-items:flex-end;justify-content:flex-start;gap:14px;padding-top:12px;border-top:1.5px solid rgba(252,99,6,.32)}.cf-totl{font-size:11px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:var(--ink-500);max-width:112px;line-height:1.4}.cf-totv{display:flex;align-items:flex-start;gap:3px;font-size:clamp(34px,3.4vw,46px);font-weight:800;letter-spacing:-.045em;line-height:.92;color:var(--text-primary);font-variant-numeric:tabular-nums}.cf-totv.is-zero{color:var(--ink-400)}.cf-totv.is-zero i{color:var(--ink-400)}.cf-totv i{font-style:normal;font-size:.4em;font-weight:700;color:var(--wb-orange);line-height:1.5}.cf-was{margin:-8px 0 0;font-size:12.5px;font-weight:700;color:var(--ink-500);text-align:right}.cf-was s{color:var(--ink-400)}.cf-cta{display:block;width:100%;text-align:center;text-decoration:none;padding:13px 20px;border:0;border-radius:var(--radius-md,12px);background:var(--wb-orange);color:var(--wb-white);font:inherit;font-size:15.5px;font-weight:800;letter-spacing:.01em;cursor:pointer;box-shadow:0 8px 22px rgba(252,99,6,.3);transition:transform var(--dur-fast) var(--ease-standard),filter var(--dur-fast) var(--ease-standard)}.cf-cta:hover{transform:translateY(-1px);filter:brightness(1.06)}.cf-cta.is-off{background:var(--sand-300);color:var(--ink-500);cursor:not-allowed;box-shadow:none;transform:none;filter:none}.cf-note{margin:0;font-size:12.5px;line-height:1.55;color:var(--text-secondary)}.cf-inc{list-style:none;margin:0;padding:12px 0 0;border-top:1px solid rgba(252,99,6,.22);display:flex;flex-direction:column;gap:7px}.cf-inc li{display:grid;grid-template-columns:14px 1fr;gap:9px;align-items:start;font-size:12.5px;font-weight:700;color:var(--text-secondary)}.cf-inc svg{width:14px;height:14px;margin-top:3px;flex:none}'), React.createElement("style", null, '.cf-ent{grid-column:1/-1;grid-row:3;display:flex;flex-direction:column;gap:8px;min-width:0;margin-top:clamp(6px,.8vw,10px)}.cf-entc{position:relative;display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);gap:clamp(14px,1.8vw,24px);background:#171717;color:#FFFFFF;border-radius:var(--radius-xl);padding:clamp(16px,1.8vw,24px);box-shadow:0 18px 40px rgba(23,23,23,.2);overflow:hidden}.cf-entl,.cf-entr{display:flex;flex-direction:column;gap:10px;min-width:0}.cf-entl{justify-content:center}.cf-enteye{font-size:10.5px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:var(--wb-gold);line-height:1.5}.cf-enth{margin:0;font-size:clamp(19px,1.8vw,25px);line-height:1.15;letter-spacing:-.025em;font-weight:800;color:#FFFFFF;text-wrap:balance}.cf-entp{margin:0;font-size:13.5px;line-height:1.55;color:#D4D4D4;max-width:52ch}.cf-entpr{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:4px}.cf-entpr>div{display:flex;flex-direction:column;gap:2px;background:#292929;border-radius:var(--radius-md);padding:10px 13px}.cf-entc .cf-entpr b{display:block;color:#FFFFFF;font-size:clamp(21px,1.9vw,26px);font-weight:800;letter-spacing:-.04em;line-height:1.15;font-variant-numeric:tabular-nums}.cf-entpr span,.cf-entt span,.cf-entql{font-size:11.5px;font-weight:700;color:#B8B8B8}.cf-entnt{margin:0;font-size:12px;line-height:1.5;font-weight:600;color:#B8B8B8}.cf-entli{list-style:none;margin:0;padding:12px 14px;display:flex;flex-direction:column;gap:7px;background:#292929;border-radius:var(--radius-md)}.cf-entli li{display:flex;align-items:flex-start;gap:9px;font-size:13px;line-height:1.4;font-weight:600}.cf-entli svg{width:14px;height:14px;flex:none;margin-top:2px}.cf-entq{display:flex;align-items:center;flex-wrap:wrap;gap:8px 12px;background:#292929;border-radius:var(--radius-md);padding:8px 12px}.cf-entql{flex:1 1 120px}.cf-entst{display:flex;align-items:center;gap:4px;background:#171717;border-radius:999px;padding:4px}.cf-entst button{all:unset;cursor:pointer;width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:800;color:#FFFFFF;transition:background var(--dur-fast) var(--ease-standard)}.cf-entst button:hover{background:#3A3A3A}.cf-entst button:disabled{opacity:.35;cursor:not-allowed;background:none}.cf-entst output{min-width:26px;text-align:center;font-size:15px;font-weight:800;font-variant-numeric:tabular-nums}.cf-entt{display:flex;flex-direction:column;align-items:flex-end;gap:2px;margin-left:auto}.cf-entc .cf-entt b{display:block;color:#FFFFFF;font-size:20px;font-weight:800;letter-spacing:-.03em;line-height:1.2;font-variant-numeric:tabular-nums}.cf-entt span{color:var(--wb-gold)}.cf-entcta{display:block;text-align:center;text-decoration:none;padding:11px 18px;border-radius:var(--radius-md);background:var(--grad-brand);color:#FFFFFF;font-size:14px;font-weight:800;line-height:1.3;box-shadow:0 8px 22px rgba(252,99,6,.3);transition:transform var(--dur-fast) var(--ease-standard),filter var(--dur-fast) var(--ease-standard)}.cf-entcta:hover{transform:translateY(-1px);filter:brightness(1.06)}@media(max-width:900px){.cf-ent{grid-row:auto}.cf-entc{grid-template-columns:minmax(0,1fr)}}@media(max-width:480px){.cf-entpr{grid-template-columns:minmax(0,1fr)}}'), React.createElement("div", {
    className: "cf-zone"
  }, React.createElement("div", {
    className: "cf-hd"
  }, React.createElement("span", {
    className: "cf-eye"
  }, React.createElement("i", null), "Commencez ici", React.createElement("i", null)), React.createElement("h3", {
    className: "cf-h3"
  }, "Choisissez votre ", React.createElement("span", {
    className: "cf-grad"
  }, "AI Phone"), " configuration."), React.createElement("p", {
    className: "cf-hlead"
  }, "Prix de configuration unique, \u00e0 vous pour toujours. Ajoutez un deuxi\u00e8me ou un troisi\u00e8me AI Phone et le rabais sur l\u2019ensemble s\u2019applique automatiquement. L\u2019utilisation est factur\u00e9e s\u00e9par\u00e9ment, \u00e0 la minute."), React.createElement("ol", {
    className: "cf-steps"
  }, React.createElement("li", null, React.createElement("b", null, "1"), React.createElement("span", null, "Choisissez vos AI Phones")), React.createElement("li", null, React.createElement("b", null, "2"), React.createElement("span", null, "Voyez votre prix unique")), React.createElement("li", null, React.createElement("b", null, "3"), React.createElement("span", null, "En service en moins de 7 jours"))), React.createElement("a", {
    className: "cf-cue",
    href: "#cf-pick"
  }, "Choisissez vos AI Phones ci-dessous", React.createElement("svg", {
    viewBox: "0 0 16 16",
    fill: "none",
    strokeWidth: "2.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M8 2.5v11M3.4 9.2 8 13.6l4.6-4.4"
  })))), React.createElement("div", {
    className: "cf-g"
  }, React.createElement("div", {
    className: "cf-pick",
    id: "cf-pick"
  }, React.createElement("div", {
    className: "cf-glb"
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-500)'
    }
  }, "Essentials"), React.createElement("i", null)), React.createElement("div", {
    className: "cf-ess"
  }, CFG.map(function (c) {
    var on = sel.includes(c.id);
    var locked = c.id === 'sms' && !sel.includes('in') && !sel.includes('out');
    return React.createElement("button", {
      key: c.id,
      type: "button",
      "aria-pressed": on,
      disabled: locked,
      className: 'cf-row' + (on ? ' is-on' : '') + (locked ? ' is-dis' : ''),
      onClick: function onClick() {
        return toggle(c.id);
      }
    }, React.createElement("span", {
      className: "cf-box"
    }, React.createElement("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      stroke: "#fff",
      strokeWidth: "2.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, React.createElement("path", {
      d: "M3 8.5 6.2 12 13 4.5"
    }))), React.createElement("span", {
      className: "cf-ico"
    }, c.id === 'orb' ? React.createElement("img", {
      src: on ? '../../assets/orbit-white.png' : '../../assets/orbit.png',
      alt: "",
      style: {
        width: 22,
        height: 22,
        objectFit: 'contain'
      }
    }) : React.createElement("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, React.createElement("path", {
      d: c.icon
    }), c.star && React.createElement("path", {
      d: c.star,
      style: {
        fill: on ? 'var(--wb-white)' : 'var(--wb-orange)',
        stroke: 'none'
      }
    }))), React.createElement("span", {
      className: "cf-rm"
    }, React.createElement("span", {
      className: "cf-rnm"
    }, c.name, c.tag && React.createElement("em", {
      className: "cf-rtag"
    }, c.tag)), React.createElement("span", {
      className: "cf-rdsc"
    }, c.desc), React.createElement("span", {
      className: "cf-rbl"
    }, c.bullets.map(function (b) {
      return React.createElement("span", {
        key: b
      }, b);
    })), c.note && React.createElement("span", {
      className: "cf-nt"
    }, c.note), React.createElement("span", {
      className: "cf-hint"
    }, locked ? 'Ajoutez d\u2019abord les appels entrants ou sortants' : on ? 'Added' : 'Ajouter \u00e0 l\u2019ensemble')), React.createElement("span", {
      className: "cf-rpr"
    }, React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 8
      }
    }, c.was && React.createElement("s", {
      style: {
        fontSize: 13,
        fontWeight: 700,
        color: 'var(--ink-400)'
      }
    }, money(c.was)), React.createElement("b", {
      style: c.was ? {
        color: 'var(--green-500)'
      } : undefined
    }, money(c.price))), React.createElement("em", null, c.was ? 'En promotion \u00b7 paiement unique' : 'Paiement unique')));
  }))), React.createElement("div", {
    className: "cf-adv"
  }, React.createElement("div", {
    className: "cf-glb"
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-500)'
    }
  }, "Advanced"), React.createElement("i", null), React.createElement("span", {
    className: "cf-gsv"
  }, "\u00c9conomisez jusqu\u2019\u00e0 744\u00a0$")), React.createElement("div", {
    className: "cf-pre g1"
  }, PRESETS.filter(function (p) {
    return p.grp === 1;
  }).map(function (p) {
    var q = quote(p.ids);
    var on = p.ids.length === sel.length && p.ids.every(function (id) {
      return sel.includes(id);
    });
    return React.createElement("button", {
      key: p.label,
      type: "button",
      className: 'cf-chip tier' + p.ids.length + (on ? ' is-on' : '') + (p.best ? ' has-badge' : ''),
      onClick: function onClick() {
        return setSel(p.ids);
      }
    }, p.best && React.createElement("span", {
      className: "cf-best"
    }, p.best), React.createElement("span", {
      className: "cf-cnm"
    }, p.label), p.sub && React.createElement("span", {
      className: "cf-csub"
    }, p.sub), React.createElement("b", null, money(q.total)), React.createElement("span", {
      className: "cf-csv"
    }, q.save > 0 ? '\u00c9conomisez ' + money(q.save) : 'Paiement unique'));
  }))), React.createElement("div", {
    className: "cf-ent"
  }, React.createElement("div", {
    className: "cf-glb"
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-500)'
    }
  }, "Enterprise"), React.createElement("i", null), React.createElement("span", {
    className: "cf-gsv",
    style: {
      color: 'var(--amber-600)'
    }
  }, "\u00c9conomisez 1\u00a0000\u00a0$ sur chaque AI Phone suppl\u00e9mentaire")), React.createElement("div", {
    className: "cf-entc"
  }, React.createElement("div", {
    className: "cf-entl"
  }, React.createElement("span", {
    className: "cf-enteye"
  }, "Multi-emplacements \u00b7 Franchises \u00b7 International"), React.createElement("div", {
    className: "cf-enth"
  }, "Une entreprise. Plusieurs march\u00e9s.", React.createElement("br", null), React.createElement("span", {
    className: "cf-grad"
  }, "Une seule exp\u00e9rience AI Phone.")), React.createElement("p", {
    className: "cf-entp"
  }, "Pour les organisations qui ont besoin de plusieurs num\u00e9ros, calendriers, \u00e9quipes ou parcours d\u2019appel, chacun configur\u00e9 pour son propre emplacement, sa langue ou sa r\u00e9gion et g\u00e9r\u00e9 depuis un seul endroit."), React.createElement("div", {
    className: "cf-entpr"
  }, React.createElement("div", null, React.createElement("b", null, "$2,997"), React.createElement("span", null, "Premier AI Phone")), React.createElement("div", null, React.createElement("b", {
    style: {
      color: 'var(--wb-gold)'
    }
  }, "$1,997"), React.createElement("span", null, "Chaque AI Phone suppl\u00e9mentaire, du m\u00eame type"))), React.createElement("p", {
    className: "cf-entnt"
  }, "Le rabais s\u2019applique aux AI Phones suppl\u00e9mentaires du m\u00eame type que le premier. Un deuxi\u00e8me AI Phone appels entrants apr\u00e8s un premier appels entrants y donne droit; un AI Phone appels sortants ajout\u00e9 \u00e0 un appels entrants est tarif\u00e9 comme un ensemble, ci-dessus.")), React.createElement("div", {
    className: "cf-entr"
  }, React.createElement("ul", {
    className: "cf-entli"
  }, ['Des num\u00e9ros locaux pour chaque march\u00e9 ou emplacement', 'Langues, calendriers et parcours d\u2019appel configur\u00e9s par site', 'Une exp\u00e9rience de marque coh\u00e9rente dans toute l\u2019organisation', 'D\u00e9ploiement coordonn\u00e9 pour toute l\u2019organisation'].map(function (b) {
    return React.createElement("li", {
      key: b
    }, React.createElement("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      stroke: "var(--wb-gold)",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, React.createElement("path", {
      d: "M3 8.5 6.2 12 13 4.5"
    })), React.createElement("span", null, b));
  })), React.createElement("div", {
    className: "cf-entq"
  }, React.createElement("span", {
    className: "cf-entql"
  }, "Combien d\u2019AI Phones?"), React.createElement("div", {
    className: "cf-entst"
  }, React.createElement("button", {
    type: "button",
    "aria-label": "Moins d\u2019AI Phones",
    onClick: function onClick() {
      return setSites(Math.max(2, sites - 1));
    },
    disabled: sites <= 2
  }, "\u2212"), React.createElement("output", null, sites), React.createElement("button", {
    type: "button",
    "aria-label": "Plus d\u2019AI Phones",
    onClick: function onClick() {
      return setSites(Math.min(99, sites + 1));
    }
  }, "+")), React.createElement("div", {
    className: "cf-entt"
  }, React.createElement("b", null, money(2997 + (sites - 1) * 1997)), React.createElement("span", null, "Vous \u00e9conomisez ", money((sites - 1) * 1000)))), React.createElement("a", {
    href: window.WB_CONFIG && window.WB_CONFIG.consultantUrl || '#final-form',
    className: "cf-entcta"
  }, "Planifier mon d\u00e9ploiement multi-emplacements avec un conseiller AI Phone \u2192")))), React.createElement("div", {
    className: "cf-sum"
  }, React.createElement("div", {
    className: "cf-shd"
  }, React.createElement(Orbit, {
    size: 44,
    state: "listening",
    detail: true,
    volume: true,
    basePath: A
  }), React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Votre AI Phone")), React.createElement("ul", {
    className: "cf-li"
  }, picked.length ? picked.map(function (c) {
    return React.createElement("li", {
      key: c.id
    }, React.createElement("span", null, c.name), picked.length > 1 && React.createElement("span", null, money(c.price)));
  }) : React.createElement("li", {
    className: "cf-empty"
  }, React.createElement("span", null, "Aucun AI Phone s\u00e9lectionn\u00e9 pour l\u2019instant"))), q.save > 0 && React.createElement("div", {
    className: "cf-sv"
  }, React.createElement("span", null, "Rabais sur l\u2019ensemble"), React.createElement("span", null, "\u2212", money(q.save))), React.createElement("div", {
    className: "cf-tot"
  }, React.createElement("span", {
    className: 'cf-totv' + (picked.length ? '' : ' is-zero')
  }, React.createElement("i", null, "$"), q.total.toLocaleString('fr-CA'))), q.save > 0 && React.createElement("p", {
    className: "cf-was"
  }, "Achet\u00e9s s\u00e9par\u00e9ment ", React.createElement("s", null, money(q.list))), picked.length ? React.createElement("a", {
    href: window.WB_BUY_HREF ? window.WB_BUY_HREF(picked.map(function (c) {
      return c.id;
    })) : '#final-form',
    className: "cf-cta"
  }, "Obtenir cette configuration") : React.createElement("span", {
    className: "cf-cta is-off",
    "aria-disabled": "true"
  }, "Choisissez un AI Phone pour continuer"), React.createElement("p", {
    className: "cf-note"
  }, "Ensuite, payez seulement les minutes pendant lesquelles il parle\u00a0: un tarif fixe de ", (RATE.toFixed(2)).replace(".", ","), "\u00a0$", "/min, en promotion \u00e0 partir de ", (LIST_RATE.toFixed(2)).replace(".", ","), "\u00a0$", " pour vos 6 premiers mois, et ", (TEXT_RATE.toFixed(2)).replace(".", ","), "\u00a0$", " par texto. Aucun abonnement mensuel au logiciel, jamais."), React.createElement("ul", {
    className: "cf-inc"
  }, ['Votre AI Phone est \u00e0 vous pour toujours, sans location', 'En service en moins de 7 jours', 'R\u00e9visions gratuites la premi\u00e8re ann\u00e9e', '7 ans de mises \u00e0 jour logicielles et de s\u00e9curit\u00e9', 'Jusqu\u2019\u00e0 4 r\u00e9visions d\u2019optimisation la premi\u00e8re ann\u00e9e', 'Disponibilit\u00e9 et surveillance 24/7', 'Financement offert, ou paiement complet'].map(function (b) {
    return React.createElement("li", {
      key: b
    }, React.createElement("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      stroke: "var(--wb-orange)",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, React.createElement("path", {
      d: "M3 8.5 6.2 12 13 4.5"
    })), React.createElement("span", null, b));
  }))))), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      marginTop: 'clamp(18px,2vw,28px)',
      marginBottom: 'clamp(12px,1.4vw,18px)'
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-500)',
      whiteSpace: 'nowrap'
    }
  }, "Ce que comprend chaque WinBoost AI Phone"), React.createElement("span", {
    style: {
      flex: 1,
      height: 1,
      background: 'var(--border-hairline)'
    }
  })), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
      gap: '14px 26px',
      alignItems: 'start',
      padding: 'clamp(16px,1.8vw,22px) clamp(18px,2vw,26px)',
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--wb-white)'
    }
  }, ['Vous poss\u00e9dez votre AI Phone personnalis\u00e9.', 'Aucun abonnement logiciel r\u00e9current pour le garder actif.', 'Disponibilit\u00e9 24/7.', '7 ans de mises \u00e0 jour logicielles et de s\u00e9curit\u00e9 inclus.', 'R\u00e9visions gratuites la premi\u00e8re ann\u00e9e.', 'Payez seulement les services que vous utilisez.'].map(function (b) {
    return React.createElement(CheckItem, {
      key: b,
      size: 17
    }, b);
  })));
}
var LIST_RATE = 0.40;
var RATE = 0.30;
var TEXT_RATE = 0.05;
var SAVE_PCT = Math.round((1 - RATE / LIST_RATE) * 100);
var DAYS = 30.5;
var STAFF_DAYS = 22;
var PRICING_FAQ = [{
  q: 'Y a-t-il des frais mensuels pour le logiciel?',
  a: 'Non. Vous achetez votre AI Phone une fois et il est \u00e0 vous. Le seul co\u00fbt r\u00e9current, ce sont les minutes pendant lesquelles il parle, factur\u00e9es par le portail client WinBoost.'
}, {
  q: 'Qu\u2019est-ce qui est inclus dans le prix \u00e0 la minute?',
  a: 'Tout ce que fait l\u2019AI Phone pendant cet appel. Comprendre l\u2019appelant, r\u00e9pondre d\u2019une voix naturelle, le qualifier, g\u00e9rer les objections, consulter votre calendrier et r\u00e9server la plage, prendre un paiement et envoyer la confirmation de suivi. Un seul tarif couvre tout l\u2019appel. Aucun frais distinct pour aucune de ces \u00e9tapes.'
}, {
  q: 'Les automatisations co\u00fbtent-elles un suppl\u00e9ment?',
  a: 'Non. Votre AI Phone, ses fonctions et sa conception sont pay\u00e9s en totalit\u00e9 d\u2019avance, avant toute mise en service. Une fois cela fait, la collecte d\u2019avis, les mises \u00e0 jour du profil d\u2019entreprise Google, les suivis par texto et l\u2019Active AI Orbit sur votre site Web fonctionnent sans frais additionnels. \u00c0 partir de l\u00e0, les deux seules lignes de votre facture sont les minutes de conversation et les textos que vous envoyez.'
}, {
  q: 'Alors, qu\u2019est-ce qui m\u2019est exactement factur\u00e9?',
  a: 'Deux frais r\u00e9currents, et rien d\u2019autre\u00a0: 0,30\u00a0$ pour chaque minute o\u00f9 votre AI Phone est en appel, et 0,05\u00a0$ pour chaque texto qu\u2019il envoie. Aucuns frais de plateforme, aucun poste par utilisateur, et aucuns frais pour les heures o\u00f9 il attend que le t\u00e9l\u00e9phone sonne. La conception de votre AI Phone est un prix unique distinct, pay\u00e9 une seule fois au d\u00e9part.'
}, {
  q: 'Ma facture peut-elle me surprendre \u00e0 la fin du mois?',
  a: 'Elle ne peut pas d\u00e9passer ce que votre volume d\u2019appels a g\u00e9n\u00e9r\u00e9. Vous voyez vos minutes s\u2019accumuler dans le portail client, alors le montant de fin de mois est un chiffre que vous suivez depuis le d\u00e9but. Pas de contrat, pas de minimum, et un mois tranquille co\u00fbte simplement moins cher.'
}, {
  q: 'Que se passe-t-il si j\u2019utilise moins de minutes que pr\u00e9vu?',
  a: 'Vous payez ce que vous utilisez. Aucun engagement minimum et aucuns frais pour les minutes non utilis\u00e9es. Un mois tranquille co\u00fbte simplement moins cher.'
}, {
  q: 'Combien de temps dure le prix du Vendredi fou?',
  a: 'Six mois \u00e0 partir du jour de la mise en service. Apr\u00e8s, les minutes reviennent au tarif standard de 0,40\u00a0$. Les textos restent \u00e0 0,05\u00a0$ dans les deux cas. Il n\u2019y a pas de palier \u00e0 franchir ni de forfait \u00e0 am\u00e9liorer\u00a0: tout le monde paie le m\u00eame tarif, que ce soit votre premi\u00e8re minute ou votre dix milli\u00e8me.'
}, {
  q: 'Et les rushs des f\u00eates et la haute saison?',
  a: 'Les semaines de pointe, c\u2019est quand le t\u00e9l\u00e9phone ne s\u2019arr\u00eate jamais, alors c\u2019est l\u00e0 que nous baissons le prix. Pendant les f\u00eates et les autres hautes saisons, les minutes viennent avec un g\u00e9n\u00e9reux rabais pour une p\u00e9riode limit\u00e9e, pour que vous r\u00e9pondiez \u00e0 chaque appel au plus fort de l\u2019achalandage sans surveiller le compteur. Quand \u00e7a roule, on est l\u00e0 pour vous! ENSEMBLE, ON WINBOOST!'
}, {
  q: 'Qu\u2019est-ce qui est inclus dans le prix unique?',
  a: 'La conception de votre AI Phone personnalis\u00e9, 7 ans de mises \u00e0 jour logicielles et de s\u00e9curit\u00e9, des r\u00e9visions gratuites la premi\u00e8re ann\u00e9e et une disponibilit\u00e9 24/7.'
}];
function Pricing() {
  var _React$useState5 = React.useState(15),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    calls = _React$useState6[0],
    setCalls = _React$useState6[1];
  var _React$useState7 = React.useState(2),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    perCall = _React$useState8[0],
    setPerCall = _React$useState8[1];
  var minsDay = calls * perCall;
  var mins = Math.round(minsDay * DAYS);
  var cost = Math.round(mins * RATE);
  var listCost = Math.round(mins * LIST_RATE);
  return React.createElement(Section, {
    id: "pricing"
  }, React.createElement(Head, {
    index: "11",
    label: "Utilisation \u00e0 la minute",
    title: "Une utilisation simple. Une tarification transparente.",
    lead: "Aucun abonnement mensuel et aucun forfait \u00e0 comparer. Payez une fois votre AI Phone, puis un seul tarif fixe pour les minutes pendant lesquelles il parle vraiment. Un vrai paiement \u00e0 l\u2019usage."
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 56,
      alignItems: 'start'
    }
  }, React.createElement("div", null, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      marginBottom: 16,
      minHeight: 'clamp(74px,6.4vw,86px)'
    }
  }, React.createElement("h3", {
    style: {
      fontSize: 'var(--fs-h3)',
      fontWeight: 800,
      letterSpacing: '-.02em',
      margin: 0
    }
  }, "Un seul tarif. Tout le monde le paie."), React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.55,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "Pas de paliers, pas de niveaux, pas de minimum. Le m\u00eame prix pour votre premi\u00e8re minute et votre dix milli\u00e8me.")), React.createElement("div", {
    style: {
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      background: 'var(--wb-white)'
    }
  }, React.createElement("div", {
    className: "wb-in-r",
    style: {
      padding: '26px 28px',
      background: '#171717',
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      flexWrap: 'wrap'
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-gold)'
    }
  }, "Prix du Vendredi fou \u00b7 6 premiers mois"), React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 800,
      letterSpacing: '.06em',
      textTransform: 'uppercase',
      color: 'var(--wb-white)',
      background: 'var(--wb-orange)',
      padding: '3px 9px',
      borderRadius: 999
    }
  }, "\u00c9conomisez ", SAVE_PCT, "\u00a0%")), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      gap: 12,
      flexWrap: 'wrap'
    }
  }, React.createElement("span", {
    style: {
      fontSize: 'clamp(40px,4.6vw,56px)',
      fontWeight: 800,
      letterSpacing: '-.04em',
      lineHeight: 1,
      color: '#FFFFFF'
    }
  }, (RATE.toFixed(2)).replace(".", ","), "\u00a0$", React.createElement("span", {
    style: {
      fontSize: '.42em',
      fontWeight: 800,
      color: 'var(--wb-gold)'
    }
  }, " /min")), React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 700,
      color: '#B8B8B8'
    }
  }, "usually ", React.createElement("s", null, (LIST_RATE.toFixed(2)).replace(".", ","), "\u00a0$", "/min"))), React.createElement("span", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.55,
      color: '#D4D4D4'
    }
  }, "Factur\u00e9 \u00e0 la seconde pendant que votre AI Phone parle vraiment.")), React.createElement("div", {
    className: "wb-in-r",
    style: {
      padding: '20px 28px',
      borderTop: '1px solid var(--border-hairline)',
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 16,
      flexWrap: 'wrap',
      animationDelay: '.08s'
    }
  }, React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 700
    }
  }, "Textos"), React.createElement("span", {
    style: {
      fontSize: 22,
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--green-500)'
    }
  }, (TEXT_RATE.toFixed(2)).replace(".", ","), "\u00a0$", React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-primary)'
    }
  }, " /SMS"))), React.createElement("div", {
    className: "wb-in-r",
    style: {
      padding: '22px 28px',
      borderTop: '1px solid var(--border-hairline)',
      animationDelay: '.16s'
    }
  }, React.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center',
      fontSize: 'clamp(17px,1.5vw,21px)',
      fontWeight: 800,
      letterSpacing: '-.01em',
      lineHeight: 1.2,
      color: 'var(--wb-orange)',
      textTransform: 'uppercase'
    }
  }, "Aucun abonnement mensuel!"))), React.createElement("div", {
    style: {
      marginTop: 'clamp(16px,1.8vw,22px)',
      fontSize: 14
    }
  }, React.createElement(Accordion, {
    items: PRICING_FAQ
  })), React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: PRICING_FAQ.map(function (f) {
          return {
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: f.a
            }
          };
        })
      })
    }
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 22
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      marginBottom: -6,
      minHeight: 'clamp(74px,6.4vw,86px)'
    }
  }, React.createElement("h3", {
    style: {
      fontSize: 'var(--fs-h3)',
      fontWeight: 800,
      letterSpacing: '-.02em',
      margin: 0
    }
  }, "Ce que \u00e7a vous co\u00fbterait."), React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.55,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "La couverture est gratuite\u00a0: vous payez les appels qu\u2019il prend, pas les heures o\u00f9 il attend. R\u00e9glez vos deux chiffres et voyez le mois.")), React.createElement("div", {
    className: "cv-dark",
    style: {
      border: '1px solid #171717',
      borderRadius: 'var(--radius-xl)',
      background: '#171717',
      color: '#FFFFFF',
      padding: '26px 28px',
      display: 'flex',
      flexDirection: 'column',
      gap: 18,
      '--text-primary': '#FFFFFF',
      '--text-secondary': '#D4D4D4',
      '--border-hairline': '#3A3A3A',
      '--ink-400': '#8A8A8A'
    }
  }, React.createElement("style", null, '.cv-dark .cv button{background:#292929;border-color:#3A3A3A}.cv-dark .cv button:hover,.cv-dark .cv button.is-on{border-color:var(--wb-gold)}.cv-dark .cv button.is-on{box-shadow:0 0 0 2px var(--wb-gold) inset}.cv-dark .cv b{color:#FFFFFF}.cv-dark .cv i{color:#B8B8B8}.cv-dark .mono{color:#B8B8B8}.cv-dark input{background:#292929!important;border-color:#3A3A3A!important;color:#FFFFFF}.cv-dark input:focus{outline:2px solid var(--wb-gold);outline-offset:1px}'), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-gold)'
    }
  }, "Quand votre AI Phone devrait-il r\u00e9pondre?"), React.createElement("span", {
    style: {
      fontSize: 15,
      lineHeight: 1.55,
      color: 'var(--text-secondary)'
    }
  }, "Choisissez une plage. Rester joignable ne co\u00fbte rien\u00a0: le compteur d\u00e9marre quand quelqu\u2019un est en ligne et s\u2019arr\u00eate quand il raccroche. Une plage plus large ne fait pas monter votre facture; elle signifie seulement moins d\u2019appels manqu\u00e9s.")), React.createElement("div", {
    className: "cv"
  }, COVER.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3),
      l = _ref4[0],
      sub = _ref4[1],
      c = _ref4[2];
    return React.createElement("button", {
      key: l,
      type: "button",
      className: calls === c ? 'is-on' : '',
      onClick: function onClick() {
        return setCalls(c);
      }
    }, React.createElement("b", null, l), React.createElement("i", null, sub));
  })), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14,
      paddingTop: 14,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("label", {
    htmlFor: "wb-calls",
    style: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--text-secondary)'
    }
  }, "Appels r\u00e9pondus par jour"), React.createElement("input", {
    id: "wb-calls",
    type: "number",
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    min: "1",
    max: "500",
    step: "1",
    value: calls,
    onChange: function onChange(e) {
      return setCalls(Math.min(500, Math.max(1, Math.round(+e.target.value) || 1)));
    },
    style: {
      width: '100%',
      padding: '9px 11px',
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-sm)',
      font: 'inherit',
      fontSize: 16,
      fontWeight: 800,
      background: 'var(--wb-white)'
    }
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("label", {
    htmlFor: "wb-percall",
    style: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--text-secondary)'
    }
  }, "Minutes par appel"), React.createElement("input", {
    id: "wb-percall",
    type: "number",
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    min: "0.5",
    max: "30",
    step: "0.5",
    value: perCall,
    onChange: function onChange(e) {
      return setPerCall(Math.min(30, Math.max(0.5, +e.target.value || 0.5)));
    },
    style: {
      width: '100%',
      padding: '9px 11px',
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-sm)',
      font: 'inherit',
      fontSize: 16,
      fontWeight: 800,
      background: 'var(--wb-white)'
    }
  }))), React.createElement("p", {
    style: {
      fontSize: 13.5,
      lineHeight: 1.5,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "La plupart des entreprises prennent un rendez-vous en environ ", React.createElement("strong", {
    style: {
      color: 'var(--text-primary)'
    }
  }, "2 minutes"), " de conversation, ce qui correspond au chiffre r\u00e9gl\u00e9 ici."), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      gap: 8,
      flexWrap: 'wrap',
      fontSize: 14.5,
      fontWeight: 700,
      color: 'var(--text-secondary)',
      paddingTop: 14,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("span", null, calls, " appels"), React.createElement("span", {
    style: {
      color: 'var(--ink-400)'
    }
  }, "\xD7"), React.createElement("span", null, perCall % 1 ? perCall.toFixed(1) : perCall, " min"), React.createElement("span", {
    style: {
      color: 'var(--ink-400)'
    }
  }, "="), React.createElement("span", {
    style: {
      color: 'var(--text-primary)',
      fontWeight: 800
    }
  }, Math.round(minsDay).toLocaleString('fr-CA'), " min par jour"), React.createElement("span", {
    style: {
      color: 'var(--ink-400)'
    }
  }, "\xD7"), React.createElement("span", null, String(DAYS).replace(".", ","), " jours"), React.createElement("span", {
    style: {
      color: 'var(--ink-400)'
    }
  }, "="), React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'baseline',
      gap: 8,
      whiteSpace: 'nowrap'
    }
  }, React.createElement("span", {
    style: {
      color: 'var(--wb-gold)',
      fontWeight: 800
    }
  }, mins.toLocaleString('fr-CA'), " min par mois"), React.createElement("span", {
    style: {
      color: 'var(--ink-400)'
    }
  }, "\xD7"), React.createElement("span", null, "(", (RATE.toFixed(2)).replace(".", ","), "\u00a0$", "/min)"), React.createElement("span", {
    style: {
      color: 'var(--ink-400)'
    }
  }, "="), React.createElement("span", {
    style: {
      color: 'var(--green-500)',
      fontWeight: 800
    }
  }, cost.toLocaleString('fr-CA'), "\u00a0$"))), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 18,
      paddingTop: 16,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  }, React.createElement("span", {
    className: "mono"
  }, "Minutes dont vous avez besoin / mois"), React.createElement("span", {
    style: {
      fontSize: 26,
      fontWeight: 800,
      letterSpacing: '-.02em'
    }
  }, mins.toLocaleString('fr-CA'))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  }, React.createElement("span", {
    className: "mono"
  }, "Utilisation \u00e0 ", (RATE.toFixed(2)).replace(".", ","), "\u00a0$", "/min"), React.createElement("span", {
    style: {
      fontSize: 26,
      fontWeight: 800,
      letterSpacing: '-.02em',
      color: 'var(--green-500)'
    }
  }, cost.toLocaleString('fr-CA'), "\u00a0$", React.createElement("span", {
    style: {
      fontSize: 14,
      color: 'var(--text-primary)',
      fontWeight: 700
    }
  }, " /mo")))), React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.6,
      color: 'var(--text-secondary)'
    }
  }, "C\u2019est environ ", React.createElement("strong", {
    style: {
      color: 'var(--wb-gold)'
    }
  }, ((cost / Math.max(1, Math.round(calls * DAYS))).toFixed(2)).replace(".", ","), "\u00a0$", " par appel"), ". Bas\u00e9 sur ", String(DAYS).replace(".", ","), " jours par mois, chaque jour du mois."), React.createElement("p", {
    style: {
      fontSize: 14,
      lineHeight: 1.6,
      color: 'var(--text-secondary)',
      paddingTop: 12,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, "Votre AI Phone peut rester joignable jour et nuit sans ajouter un sou \u00e0 ce chiffre\u00a0: le compteur ne tourne que pendant un appel. Si un mois tranquille apporte moins d\u2019appels, vous payez simplement moins.")), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'get-your-ai-phone') : '#final-form'
  }, "Obtenez votre AI Phone")))));
}
function BookingRoi() {
  var _React$useState9 = React.useState(120),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    bookings = _React$useState0[0],
    setBookings = _React$useState0[1];
  var _React$useState1 = React.useState(2),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    minsPer = _React$useState10[0],
    setMinsPer = _React$useState10[1];
  var _React$useState11 = React.useState(400),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    ticket = _React$useState12[0],
    setTicket = _React$useState12[1];
  var rnd = function rnd(v) {
    var m = Math.pow(10, Math.floor(Math.log10(v)) - 1);
    return Math.round(v / m) * m;
  };
  var tpos = Math.round(100 * Math.log(Math.max(10, ticket) / 10) / Math.log(100000));
  var numIn = {
    width: 96,
    padding: '6px 8px',
    border: '1px solid var(--border-card)',
    borderRadius: 'var(--radius-sm)',
    font: 'inherit',
    fontSize: 15,
    fontWeight: 700,
    background: 'var(--wb-white)'
  };
  var total = Math.round(bookings * minsPer);
  var aiPer = RATE * minsPer;
  var monthlyAi = total * RATE;
  var monthlyValue = bookings * ticket;
  var share = monthlyAi / monthlyValue * 100;
  var missed = Math.round(bookings * 0.25) * ticket;
  var A = '../../assets/';
  var money = function money(n) {
    return n.toLocaleString('fr-CA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + "\u00a0$";
  };
  return React.createElement(Section, {
    id: "booking-roi",
    style: {
      background: 'linear-gradient(0deg,#FFAE06 0%,#FC6306 100%)',
      borderTop: 'none'
    }
  }, React.createElement("div", {
    style: {
      '--text-primary': '#FFFFFF',
      '--text-secondary': '#FFFFFF',
      '--ink-400': '#FFFFFF',
      '--border-hairline': 'rgba(255,255,255,.4)',
      color: '#FFFFFF'
    }
  }, React.createElement(Head, {
    index: "12",
    label: "Co\u00fbt par r\u00e9servation",
    title: "Combien co\u00fbte un rendez-vous r\u00e9serv\u00e9?",
    lead: "Votre AI Phone est factur\u00e9 seulement pour les minutes pendant lesquelles il parle vraiment. R\u00e9glez vos chiffres ci-dessous et voyez ce que vous co\u00fbte un rendez-vous r\u00e9serv\u00e9, et ce qu\u2019il vaut."
  })), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,.9fr) minmax(0,1.25fr)',
      gap: 'clamp(28px,3.4vw,56px)',
      alignItems: 'start'
    }
  }, React.createElement("div", {
    className: "wb-in-up",
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, React.createElement("div", {
    style: {
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-xl)',
      background: 'var(--wb-white)',
      boxShadow: '0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card)',
      padding: '26px 28px',
      display: 'flex',
      flexDirection: 'column',
      gap: 24
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, React.createElement("label", {
    htmlFor: "wb-bk",
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Rendez-vous r\u00e9serv\u00e9s / mois"), React.createElement("span", {
    style: {
      fontSize: 36,
      fontWeight: 800,
      letterSpacing: '-.03em'
    }
  }, bookings), React.createElement("input", {
    type: "number",
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    min: "1",
    max: "1000",
    value: bookings,
    onChange: function onChange(e) {
      return setBookings(Math.min(1000, Math.max(1, +e.target.value || 1)));
    },
    style: numIn,
    "aria-label": "Saisissez les rendez-vous r\u00e9serv\u00e9s par mois"
  }), React.createElement("input", {
    id: "wb-bk",
    type: "range",
    min: "1",
    max: "1000",
    step: "1",
    value: bookings,
    onChange: function onChange(e) {
      return setBookings(+e.target.value);
    },
    style: {
      width: '100%'
    }
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      paddingTop: 18,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("label", {
    htmlFor: "wb-mp",
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Minutes pour r\u00e9server un rendez-vous"), React.createElement("span", {
    style: {
      fontSize: 36,
      fontWeight: 800,
      letterSpacing: '-.03em'
    }
  }, minsPer % 1 ? minsPer.toFixed(1) : minsPer, React.createElement("span", {
    style: {
      fontSize: 16,
      fontWeight: 700,
      color: 'var(--text-secondary)'
    }
  }, " min")), React.createElement("input", {
    id: "wb-mp",
    type: "range",
    min: "1",
    max: "60",
    step: "0.5",
    value: minsPer,
    onChange: function onChange(e) {
      return setMinsPer(+e.target.value);
    },
    style: {
      width: '100%'
    }
  })), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      paddingTop: 18,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("label", {
    htmlFor: "wb-tk",
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Valeur moyenne d\u2019une r\u00e9servation"), React.createElement("span", {
    style: {
      fontSize: 36,
      fontWeight: 800,
      letterSpacing: '-.03em'
    }
  }, ticket.toLocaleString('fr-CA'), "\u00a0$"), React.createElement("input", {
    type: "number",
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    min: "10",
    max: "1000000",
    step: "10",
    value: ticket,
    onChange: function onChange(e) {
      return setTicket(Math.min(1000000, Math.max(10, +e.target.value || 10)));
    },
    style: numIn,
    "aria-label": "Saisissez la valeur moyenne d\u2019une r\u00e9servation"
  }), React.createElement("input", {
    id: "wb-tk",
    type: "range",
    min: "0",
    max: "100",
    step: "1",
    value: tpos,
    onChange: function onChange(e) {
      return setTicket(rnd(10 * Math.pow(100000, +e.target.value / 100)));
    },
    style: {
      width: '100%'
    }
  })), React.createElement("p", {
    style: {
      fontSize: 14,
      lineHeight: 1.6,
      color: 'var(--text-secondary)'
    }
  }, bookings, " r\u00e9servations \u00d7 ", minsPer % 1 ? minsPer.toFixed(1) : minsPer, " min = ", React.createElement("strong", {
    style: {
      color: 'var(--text-primary)'
    }
  }, total.toLocaleString('fr-CA'), " minutes"), " par mois \u00e0 un tarif fixe de ", (RATE.toFixed(2)).replace(".", ","), "\u00a0$", "/min. Le tarif ne change jamais selon le volume : le co\u00fbt par r\u00e9servation reste le m\u00eame, peu importe l\u2019\u00e9chelle."))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, React.createElement("div", {
    style: {
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-xl)',
      background: 'var(--wb-white)',
      boxShadow: '0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card)',
      overflow: 'hidden'
    }
  }, [['AI Phone, par rendez-vous r\u00e9serv\u00e9', money(aiPer), 'var(--wb-orange)'], ['Valeur de cette r\u00e9servation pour vous', ticket.toLocaleString('fr-CA') + "\u00a0$", null], ['AI Phone, ' + total.toLocaleString('fr-CA') + ' minutes de conversation / mois', Math.round(monthlyAi).toLocaleString('fr-CA') + "\u00a0$", 'var(--wb-orange)'], ['Revenus r\u00e9serv\u00e9s, ' + bookings + ' rendez-vous / mois', monthlyValue.toLocaleString('fr-CA') + "\u00a0$", null], ['Votre AI Phone co\u00fbte', (share.toFixed(share < 1 ? 2 : 1)).replace(".", ",") + '\u00a0% de ce revenu', null]].map(function (_ref5, i) {
    var _ref6 = _slicedToArray(_ref5, 3),
      l = _ref6[0],
      v = _ref6[1],
      c = _ref6[2];
    return React.createElement("div", {
      key: l,
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: 16,
        padding: '16px 24px',
        borderTop: i ? '1px solid var(--border-hairline)' : 'none'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 700
      }
    }, l), React.createElement("span", {
      style: {
        fontSize: 22,
        fontWeight: 800,
        letterSpacing: '-.02em',
        color: c || 'var(--text-primary)'
      }
    }, v));
  }), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      gap: 16,
      padding: '18px 24px',
      borderTop: '1px solid var(--border-card)',
      background: 'var(--grad-brand-soft)'
    }
  }, React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800
    }
  }, "Vous gardez, par mois"), React.createElement("span", {
    style: {
      fontSize: 28,
      fontWeight: 800,
      letterSpacing: '-.03em',
      color: 'var(--green-500)'
    }
  }, Math.round(monthlyValue - monthlyAi).toLocaleString('fr-CA'), "\u00a0$"))), React.createElement("div", {
    style: {
      border: '1px solid var(--wb-orange)',
      borderRadius: 'var(--radius-xl)',
      background: 'var(--wb-white)',
      padding: '22px 24px',
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Le VRAI co\u00fbt de ne pas int\u00e9grer notre AI Phone \u00e0 votre entreprise"), React.createElement("span", {
    style: {
      fontSize: 30,
      fontWeight: 800,
      letterSpacing: '-.03em'
    }
  }, missed.toLocaleString('fr-CA'), "\u00a0$"), React.createElement("span", {
    style: {
      fontSize: 14,
      lineHeight: 1.6,
      color: 'var(--text-secondary)'
    }
  }, "Si un appel sur quatre reste sans r\u00e9ponse aujourd\u2019hui, \u00e7a fait ", Math.round(bookings * 0.25), " rendez-vous par mois jamais r\u00e9serv\u00e9s, \u00e0 ", ticket.toLocaleString('fr-CA'), "\u00a0$", " chacun. Votre AI Phone r\u00e9pond \u00e0 tous pour ", Math.round(monthlyAi).toLocaleString('fr-CA'), "\u00a0$", ".")), React.createElement("p", {
    className: "mono",
    style: {
      color: '#FFFFFF'
    }
  }, "Par r\u00e9servation = ", (RATE.toFixed(2)).replace(".", ","), "\u00a0$", " \u00d7 minutes par appel. Votre AI Phone couvre les 24 heures et n\u2019est factur\u00e9 que pour les minutes de conversation\u00a0: aucune heure de couverture, aucun temps mort."))));
}
var CMP_COLS = [['WinBoost AI Phone', '\u00c0 partir de 2\u00a0997\u00a0$, une fois'], ['T\u00e9l\u00e9phone de bureau Cisco', 'N\u00e9cessite une personne'], ['iPhone Duo', '3\u00a0900\u00a0$'], ['Samsung Z Fold', '$3,200'], ['R\u00e9ceptionniste de bureau', '~3\u00a0400\u00a0$ / mois']];
var CMP_ROWS = [['R\u00e9ponse', [['R\u00e9pond \u00e0 chaque appel, 24/7', ['y', 'n', 'n', 'n', '~Heures de bureau']], ['Appels trait\u00e9s en m\u00eame temps', ['20 appels', '~1 par ligne', '~1', '~1', '~1']], ['Fonctionne sans que personne ne l\u2019op\u00e8re', ['y', 'n', 'n', 'n', 'n']], ['Couvre les d\u00eeners, les cong\u00e9s de maladie et les jours f\u00e9ri\u00e9s', ['y', 'n', 'n', 'n', 'n']], ['Parle toutes les langues, change en cours d\u2019appel', ['Toutes les langues', 'n', 'n', 'n', '~G\u00e9n\u00e9ralement une']]]], ['Gagner le client', [['R\u00e9serve des rendez-vous dans votre calendrier', ['y', 'n', '~Manuellement', '~Manuellement', 'y']], ['Rappels par texto 24 h et 2 h avant', ['y', 'n', '~Manuellement', '~Manuellement', '~Manuellement']], ['Appels de suivi sortants', ['y', 'n', '~Manuellement', '~Manuellement', '~Manuellement']], ['Collecte des avis 5 \u00e9toiles par texto', ['y', 'n', '~Manuellement', '~Manuellement', '~Parfois']], ['Site Web vocal (Active AI Orbit)', ['y', 'n', 'n', 'n', 'n']], ['Chaque appel transcrit et r\u00e9sum\u00e9', ['y', 'n', 'n', 'n', 'n']]]], ['Co\u00fbt', [['D\u2019avance', ['2\u00a0997\u00a0$, une fois', '~450\u00a0$ + installation', '~3\u00a0900\u00a0$', '~3\u00a0200\u00a0$', '~Embauche + formation']], ['Chaque mois', ['0,30\u00a0$ / min utilis\u00e9e', '~Ligne + salaire du personnel', '~Forfait + votre temps', '~Forfait + votre temps', '~3\u00a0400\u00a0$ de salaire']], ['Abonnement mensuel', ['JAMAIS', '~Oui', '~Oui', '~Oui', '~Paie']]]]];
function Compare() {
  var G = 'minmax(180px,1.4fr) minmax(170px,1.25fr) repeat(4,minmax(110px,1fr))';
  var WB = 'rgba(255,174,6,.09)';
  var mark = function mark(v, w) {
    return v === 'y' ? React.createElement("span", {
      style: {
        display: 'inline-grid',
        placeItems: 'center',
        width: 26,
        height: 26,
        borderRadius: 999,
        background: w ? 'var(--wb-orange)' : '#171717',
        color: 'var(--wb-white)',
        fontSize: 14,
        fontWeight: 800
      }
    }, "\u2713") : v === 'n' ? React.createElement("span", {
      style: {
        color: 'var(--ink-400)',
        fontWeight: 600,
        fontSize: 13.5
      }
    }, "Non") : v[0] === '~' ? React.createElement("span", {
      style: {
        fontSize: 13.5,
        fontWeight: 600,
        color: 'var(--text-secondary)'
      }
    }, v.slice(1)) : React.createElement("span", {
      style: {
        fontSize: w ? 15 : 14,
        fontWeight: 800,
        color: w ? 'var(--wb-orange)' : 'var(--text-primary)'
      }
    }, v);
  };
  var r = 0;
  return React.createElement(Section, {
    id: "compare",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    index: "13",
    label: "Comparaison",
    title: "Tout autre t\u00e9l\u00e9phone a besoin de quelqu\u2019un pour r\u00e9pondre.",
    lead: "Un t\u00e9l\u00e9phone de bureau, un t\u00e9l\u00e9phone intelligent haut de gamme et une r\u00e9ceptionniste d\u00e9pendent tous d\u2019une personne libre au moment de l\u2019appel. Votre AI Phone r\u00e9pond \u00e0 chaque appel, r\u00e9serve, fait le suivi et demande l\u2019avis."
  }), React.createElement("div", {
    className: "wb-cmp-d",
    style: {
      overflowX: 'auto',
      margin: '0 -4px',
      padding: '14px 4px 4px'
    }
  }, React.createElement("div", {
    style: {
      minWidth: 820,
      border: '1px solid #171717',
      borderRadius: 'var(--radius-xl)',
      background: 'var(--wb-white)',
      boxShadow: '0 24px 60px -30px rgba(23,23,23,.35)'
    }
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: G,
      alignItems: 'stretch'
    }
  }, React.createElement("div", {
    style: {
      padding: '22px 22px',
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: '#171717'
    }
  }, "Ce qui compte")), CMP_COLS.map(function (_ref7, i) {
    var _ref8 = _slicedToArray(_ref7, 2),
      n = _ref8[0],
      sub = _ref8[1];
    return i === 0 ? React.createElement("div", {
      key: n,
      style: {
        margin: '-14px 0 0',
        padding: '20px 16px 18px',
        textAlign: 'center',
        background: 'linear-gradient(135deg,#FFAE06,#FC6306)',
        borderRadius: '16px 16px 0 0',
        color: 'var(--wb-white)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        boxShadow: '0 -6px 24px rgba(252,99,6,.22)'
      }
    }, React.createElement("img", {
      src: "../../assets/orbit-white.png",
      alt: "",
      style: {
        width: 26,
        height: 26,
        objectFit: 'contain'
      }
    }), React.createElement("span", {
      style: {
        fontSize: 16,
        fontWeight: 800,
        letterSpacing: '-.01em'
      }
    }, n), React.createElement("span", {
      style: {
        fontSize: 12.5,
        fontWeight: 700
      }
    }, sub)) : React.createElement("div", {
      key: n,
      style: {
        padding: '22px 12px 18px',
        textAlign: 'center',
        borderLeft: i > 1 ? '1px solid var(--border-hairline)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: 4
      }
    }, React.createElement("span", {
      style: {
        fontSize: 14,
        fontWeight: 800,
        color: '#171717'
      }
    }, n), React.createElement("span", {
      style: {
        fontSize: 12.5,
        fontWeight: 600,
        color: 'var(--text-secondary)'
      }
    }, sub));
  })), CMP_ROWS.map(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 2),
      grp = _ref0[0],
      rows = _ref0[1];
    return React.createElement(React.Fragment, {
      key: grp
    }, React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: G,
        borderTop: '1px solid #171717',
        background: '#171717'
      }
    }, React.createElement("div", {
      style: {
        padding: '11px 22px'
      }
    }, React.createElement("span", {
      className: "wb-label",
      style: {
        color: 'var(--wb-gold)'
      }
    }, grp)), React.createElement("div", {
      style: {
        background: '#292929',
        borderLeft: '2px solid var(--wb-orange)',
        borderRight: '2px solid var(--wb-orange)'
      }
    }), React.createElement("div", {
      style: {
        gridColumn: 'span 4'
      }
    })), rows.map(function (_ref1) {
      var _ref10 = _slicedToArray(_ref1, 2),
        c = _ref10[0],
        vals = _ref10[1];
      var d = r++;
      return React.createElement("div", {
        key: c,
        style: {
          display: 'grid',
          gridTemplateColumns: G,
          borderTop: '1px solid var(--border-hairline)'
        }
      }, React.createElement("div", {
        style: {
          padding: '15px 22px',
          fontSize: 15,
          fontWeight: 700
        }
      }, c), vals.map(function (v, i) {
        return React.createElement("div", {
          key: i,
          style: _objectSpread({
            padding: '15px 12px',
            display: 'grid',
            placeItems: 'center',
            textAlign: 'center'
          }, i === 0 ? {
            background: WB,
            borderLeft: '2px solid var(--wb-orange)',
            borderRight: '2px solid var(--wb-orange)'
          } : {
            borderLeft: i > 1 ? '1px solid var(--border-hairline)' : 'none'
          })
        }, mark(v, i === 0));
      }));
    }));
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: G,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("div", {
    style: {
      padding: '18px 22px',
      fontSize: 14,
      lineHeight: 1.5,
      color: 'var(--text-secondary)'
    }
  }, "Payez une fois. Ensuite, seulement les minutes pendant lesquelles il parle."), React.createElement("div", {
    style: {
      padding: '16px 8px 20px',
      background: WB,
      borderLeft: '2px solid var(--wb-orange)',
      borderRight: '2px solid var(--wb-orange)',
      borderBottom: '2px solid var(--wb-orange)',
      borderRadius: '0 0 16px 16px',
      display: 'grid',
      placeItems: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'get-started') : '#final-form',
    style: {
      whiteSpace: 'nowrap'
    }
  }, "Commencer")), React.createElement("div", {
    style: {
      gridColumn: 'span 4'
    }
  })))), window.WB_CMP_MOBILE ? React.createElement(window.WB_CMP_MOBILE, {
    cols: CMP_COLS,
    rows: CMP_ROWS,
    cta: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('compare', 'get-started') : '/products/ai-phone'
  }) : null, React.createElement("p", {
    className: "mono",
    style: {
      marginTop: 16
    }
  }, "Prix des appareils tels qu\u2019affich\u00e9s. Les autres co\u00fbts sont des estimations typiques nord-am\u00e9ricaines; le salaire exclut les avantages sociaux et les charges salariales."));
}
Object.assign(window, {
  Onboarding: Onboarding,
  Products: Products,
  Pricing: Pricing,
  BookingRoi: BookingRoi,
  Compare: Compare
});